<mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
<section *ngFor="let studium of data" class="mt-3">
  <app-studium-item [data]="studium"></app-studium-item>
</section>
